import styled, { css } from 'styled-components'
import Image from 'next/image'
import Link from 'src/components/Link'

import MegaMenu from '../../components/MegaMenu'

export const SlotContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
`

export const Menu = styled(MegaMenu)<{ $isOpen: boolean }>`
  position: absolute;
  z-index: ${({ theme }) => theme.zIndexes.navigation};
  width: 100%;
  top: 100%;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-3rem);
  transition: all 0.3s ease;

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    `}
`

export const Logo = styled(Image)`
  width: 20rem;

  ${({ theme }) => theme.breakpoints.down('tablet')} {
    width: 13rem;
  }
`

export const LogoLink = styled(Link)`
  ${({ theme }) => theme.breakpoints.down('mobile')} {
    display: none;
  }
`
